import { Button } from 'primereact/button';
import { Panel as PrimePanel } from 'primereact/panel';
import { MutableRefObject, ReactNode, useMemo, useState } from 'react';
import { PanelProps } from '../Panel';

export function IconOnlyHeaderTemplate(
    props: PanelProps,
    panelRef: MutableRefObject<PrimePanel | null>,
): ReactNode {
    const [isCollapsed, setCollapsed] = useState<boolean>(
        props.collapsed ?? false,
    );
    const baseClass = 'panel-toggle-icon-only';
    const buttonClass = useMemo(
        () => (isCollapsed ? baseClass : `active ${baseClass}`),
        [isCollapsed],
    );

    if (!panelRef || !props.iconOnly) {
        return null;
    }

    return (
        <Button
            className={buttonClass}
            icon={props.header}
            onClick={() => {
                setCollapsed(!isCollapsed);
                panelRef.current?.toggle(undefined);
            }}
        />
    );
}
